<template>
    <div class="invoicePay-firstStep">
        <InvoicePayFormField
            field="payment-form-firstName"
            v-model="form['invoice-id']"
            :validation="$v.form['invoice-id']"
            label="ID счёта"
        />
        <div
            :class="[
                'invoicePay-firstStep__submit btn',
                { '__invalid': $v.$invalid || sending }
            ]"
            @click="sendForm"
        >
            Продолжить
        </div>
    </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators';
import InvoicePayFormField from "@/components/invoicePay/InvoicePayFormField";
import formData from "@/assets/js/_formData";
import axios from "axios";

export default {
    name: "InvoicePayFirstStep",
    components: {
        InvoicePayFormField
    },
    data() {
        return {
            form: {
                'invoice-id': ''
            },
            sending: false
        }
    },
    methods: {
        sendForm() {
            if (this.$v.$invalid) return;

            const request = formData(this.form);
            this.sending = true;

            axios({
                url: '/invoice-pay/index.php',
                method: 'post',
                data: request,
                headers: {
                    'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'data-type': 'json',
                    'x-requested-with': 'XMLHttpRequest'
                }
            }).then(response => {
                this.sending = false;
                if (response.data.invoice !== null && response.data.error.length === 0) {
                    console.log(response.data.error.length)
                    this.$emit('goToSecond', {
                        user: response.data.user,
                        invoice: response.data.invoice
                    });
                }
                else if (response.data.error === 'Счет был оплачен ранее') {
                    this.$emit('goToPayment');
                }
                else {
                    this.$emit('goToNotFound');
                }
            })
        }
    },
    validations() {
        return {
            form: {
                'invoice-id': {
                    required,
                    maxLength: maxLength(50),
                }}
        }
    }
}
</script>

<style lang="scss">
@import '../../assets/scss/mixins-and-vars';

.invoicePay-firstStep {
    margin-top: 20px;

    @include mobile {
        margin-top: 15px;
    }

    &__submit {
        padding: 15px 48px;
        margin-top: 30px;
        border-radius: 8px;
        font-weight: 500;
        font-size: 16px;

        border: none;
        background-color: #00b2ac;
        text-align: center;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        height: 46px;
        line-height: 1;
        transition: .2s;
        outline: 0;
        user-select: none;
        white-space: nowrap;

        @include mobile {
            margin-top: 15px;
        }

        &.__invalid {
            opacity: .4;
            pointer-events: none;
        }
    }
}
</style>